<div
  class="tw-rounded-xl tw-p-4 tw-shadow-elevation-card"
  [ngClass]="backgroundClass || 'tw-bg-color-surface-card'"
>
  @if (hasHeaderContent) {
    <div
      class="tw-mb-4 tw-flex tw-justify-between tw-flex-row sm:tw-flex-col sm:tw-space-y-3 sm:tw-items-start"
    >
      @if (!hideIcon) {
        <div class="tw-flex tw-items-center">
          <icon
            [size]="6"
            [name]="iconName"
            [currentColor]="'neutral-600'"
            class="bordered-icon"
          ></icon>
          <span
            class="tw-ml-2 tw-text-lg tw-font-medium tw-uppercase tw-text-dt-text-secondary sm:tw-text-sm"
            [ngClass]="titleClass"
            >{{ title }}</span
          >
        </div>
      }

      <ng-content select="[titleWidget]"></ng-content>
      <ng-container *ngTemplateOutlet="widgetMenu"></ng-container>
      <ng-content select="[action]"></ng-content>
    </div>
  }
  <ng-content></ng-content>
</div>

<ng-template #widgetMenu>
  @if (menu) {
    <div class="tw-rounded-xl tw-bg-dt-surface-elevated tw-p-1">
      <div class="tw-flex tw-cursor-pointer tw-items-center tw-gap-1">
        @if (menu.type === "text") {
          <div
            *ngFor="let option of menu.options"
            class="tw-p-2"
            [ngClass]="{ 'widget-menu-selected': option.isSelected }"
            (click)="onOptionClick(option.value)"
          >
            {{ option.displayValue | capitalise }}
          </div>
        }

        @if (menu.type === "icon") {
          <icon
            *ngFor="let option of menu.options"
            class="tw-p-1"
            [ngClass]="{ 'widget-menu-selected': option.isSelected }"
            [size]="5"
            (click)="onOptionClick(option.value)"
            [name]="option.displayValue"
          >
          </icon>
        }
      </div>
    </div>
  }
</ng-template>
